import { memo, useState, useCallback } from 'react';
import { CaseReportReviewActions } from '@/components/casereport/CaseReportReviewActions';
import { CaseReportAuditLog } from '@/components/casereport/CaseReportAuditLog';
import { ConfirmModal } from '@/components/ConfirmModal';
import { App } from '@/services/app-compat';

interface Props {
  report: any;
  hasReportApproval: boolean;
  isAuthor: boolean;
  canUnapprove: boolean;
  onSubmitForApproval: () => void;
  onApprove: () => void;
  onUnapprove: () => void;
  onReturnToAuthor: (comment: string) => void;
}

export const CaseReportReviewSection = memo(function CaseReportReviewSection({
  report, hasReportApproval, isAuthor, canUnapprove,
  onSubmitForApproval, onApprove, onUnapprove, onReturnToAuthor,
}: Props) {
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnComment, setReturnComment] = useState('');

  const submitReturn = useCallback(() => {
    if (!returnComment.trim()) {
      App.showPopupNotification('Please enter a comment explaining why you are returning the report.', 'warning'); return;
    }
    onReturnToAuthor(returnComment);
    setShowReturnModal(false);
    setReturnComment('');
  }, [returnComment, onReturnToAuthor]);

  return (
    <>
      <CaseReportReviewActions
        report={report}
        hasReportApproval={hasReportApproval}
        isAuthor={isAuthor}
        canUnapprove={canUnapprove}
        onSubmitForApproval={onSubmitForApproval}
        onReturnToAuthor={() => { setReturnComment(''); setShowReturnModal(true); }}
        onApprove={onApprove}
        onUnapprove={onUnapprove}
      />
      {report.id && (
        <CaseReportAuditLog reportId={report.id} />
      )}

      <ConfirmModal
        open={showReturnModal}
        title="Return to Author"
        confirmText="Return to Author"
        confirmClass="warning"
        onConfirm={submitReturn}
        onCancel={() => { setShowReturnModal(false); setReturnComment(''); }}
      >
        <div className="form-group">
          <label className="control-label">Please add a comment explaining why you are returning the incident report to the author:</label>
          <textarea className="form-control" value={returnComment}
            onChange={e => setReturnComment(e.target.value)} rows={5}
            placeholder="Enter your comment here..." />
        </div>
      </ConfirmModal>
    </>
  );
});
